import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1af92ee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-label" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider mb-4" }, null, -1))
const _hoisted_3 = { class: "invest-detail-container" }
const _hoisted_4 = { class: "invest-detail-label" }
const _hoisted_5 = { class: "invest-detail-value balance" }
const _hoisted_6 = {
  key: 0,
  class: "invest-detail-container"
}
const _hoisted_7 = { class: "invest-detail-label" }
const _hoisted_8 = { class: "invest-detail-value balance" }
const _hoisted_9 = {
  key: 1,
  class: "invest-detail-container"
}
const _hoisted_10 = { class: "invest-detail-label" }
const _hoisted_11 = { class: "invest-detail-value balance" }
const _hoisted_12 = {
  key: 2,
  class: "invest-detail-container"
}
const _hoisted_13 = { class: "invest-detail-label" }
const _hoisted_14 = { class: "invest-detail-value text-blue-520 dark:text-emerald-490" }
const _hoisted_15 = {
  key: 3,
  class: "mt-6"
}
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = { class: "main-label" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider mb-3" }, null, -1))
const _hoisted_20 = { class: "invest-detail-container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-detail-label" }, null, -1))
const _hoisted_22 = { class: "onsen-dual-value-title" }
const _hoisted_23 = {
  key: 0,
  class: "onsen-dual-end-title"
}
const _hoisted_24 = { class: "invest-detail-label" }
const _hoisted_25 = { class: "onsen-dual-value onsen-dual-token-value" }
const _hoisted_26 = { class: "onsen-dual-usd-value" }
const _hoisted_27 = {
  key: 0,
  class: "onsen-dual-end"
}
const _hoisted_28 = {
  key: 4,
  class: "mt-6"
}
const _hoisted_29 = { class: "flex relative" }
const _hoisted_30 = { class: "main-label w-full justify-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider mb-3" }, null, -1))
const _hoisted_32 = { class: "invest-detail-container onsen-detail-title" }
const _hoisted_33 = { class: "onsen-detail-partner" }
const _hoisted_34 = {
  key: 0,
  class: "onsen-detail-start"
}
const _hoisted_35 = { class: "onsen-detail-end" }
const _hoisted_36 = { class: "onsen-detail-total" }
const _hoisted_37 = { class: "onsen-detail-partner" }
const _hoisted_38 = {
  key: 0,
  class: "onsen-detail-start"
}
const _hoisted_39 = { class: "onsen-detail-end" }
const _hoisted_40 = { class: "onsen-detail-total" }
const _hoisted_41 = { class: "onsen-detail-usd-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('investment.label')), 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('wallet')) + ":", 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.farmVault.vault
            ? _ctx.farmVault.walletEmpty
              ? '--'
              : `${_ctx.showTokenBalance(
                  _ctx.farmVault.vault.stats.value.userBalanceNormalized
                )} ${_ctx.farmVault.vault.tokenSymbol} ${
                  _ctx.farmVault.vault.stats.value.userBalanceUsd
                    ? `($${_ctx.fwp(_ctx.farmVault.vault.stats.value.userBalanceUsd)})`
                    : ''
                }`
            : _ctx.farmVault.walletFarmEmpty
            ? '--'
            : `${_ctx.showTokenBalance(_ctx.farmVault.farm.stats.value.userBalance)} ${
                _ctx.farmVault.farm.tokenSymbol
              } ${
                _ctx.farmVault.farm.stats.value.userBalanceUsd
                  ? `($${_ctx.fwp(_ctx.farmVault.farm.stats.value.userBalanceUsd)})`
                  : ''
              }`), 1)
    ]),
    (!_ctx.farmVault.vaultEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('vault')) + ":", 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(`${_ctx.showTokenBalance(
            _ctx.farmVault.vault.stats.value.userBalanceVaultInTokenNormalized
          )} ${_ctx.farmVault.vault.tokenSymbol} ${
            _ctx.farmVault.vault.stats.value.userBalanceVaultUsd
              ? `($${_ctx.fwp(_ctx.farmVault.vault.stats.value.userBalanceVaultUsd)})`
              : ''
          }`), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.farmVault.farmEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.farmVault.vault ? _ctx.$t('vault_farm') : _ctx.$t('farm')) + ": ", 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(`${_ctx.showTokenBalance(
            _ctx.farmVault.farm.stats.value.userBalanceFarmInVaultTokenNormalized ||
              _ctx.farmVault.farm.stats.value.userBalanceFarm
          )} ${
            _ctx.farmVault.farm.stats.value.userBalanceFarmInVaultTokenNormalized
              ? _ctx.farmVault.vault.tokenSymbol
              : _ctx.farmVault.farm.tokenSymbol
          } ${
            _ctx.farmVault.farm.stats.value.userBalanceFarmUsd
              ? `($${_ctx.fwp(_ctx.farmVault.farm.stats.value.userBalanceFarmUsd)})`
              : ''
          }`), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.farmVault.pendingEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('pending')) + ":", 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(`${_ctx.showTokenBalance(_ctx.farmVault.farm.stats.value.rewardPending)} 
            ${_ctx.farmVault.farm.masterFarm?.rewardTokenSymbol} ${
            _ctx.farmVault.farm.stats.value.rewardPendingUsd
              ? `($${_ctx.fwp(_ctx.farmVault.farm.stats.value.rewardPendingUsd)})`
              : ''
          }`), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.additionalPoolRewardsToShow?.length && !_ctx.showOnsenDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.farmVault.name === 'A2B2 (ACSI)'
              ? _ctx.$t('pending_onsen_rewards')
              : _ctx.$t('pending_dual_rewards')) + " ", 1),
              _createVNode(_component_BalTooltip, null, {
                activator: _withCtx(() => [
                  _createVNode(_component_BalIcon, {
                    name: "akar-icons:info",
                    size: "xs",
                    class: "ml-1 text-zink-400"
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _ctx.$t('pending_rewardsToolTips'),
                    class: "w-120"
                  }, null, 8, _hoisted_18)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_BalIcon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showOnsenDetail = !_ctx.showOnsenDetail)),
              class: "cursor-pointer text-amber-550",
              name: "bi:clock-history",
              size: "sm"
            })
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.farmVault.name === 'A2B2 (ACSI)'
              ? _ctx.$t('pending_onsen_rewards')
              : _ctx.$t('pending_dual_rewards')), 1),
            (!_ctx.upToLargeBreakpoint)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('est_end_of_emission')), 1))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalPoolRewardsToShow, (additionalPoolReward, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "invest-detail-container"
            }, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(`${additionalPoolReward.tokenSymbol}:`), 1),
              _createElementVNode("div", _hoisted_25, [
                _createTextVNode(_toDisplayString(additionalPoolReward.tokenValue) + " ", 1),
                _createElementVNode("span", _hoisted_26, _toDisplayString(additionalPoolReward.usdValue), 1)
              ]),
              (!_ctx.upToLargeBreakpoint)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(index === 0
              ? additionalPoolReward.endEmission
              : additionalPoolReward.diffDays), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.additionalPoolRewardsToShow?.length && _ctx.showOnsenDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.farmVault.name === 'A2B2 (ACSI)'
              ? _ctx.$t('onsen_emissions_details')
              : _ctx.$t('dual_rewards_emission_details')), 1),
            _createVNode(_component_BalBtn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showOnsenDetail = !_ctx.showOnsenDetail)),
              class: "absolute right-0 -top-1",
              circle: "",
              outline: "",
              color: "zink",
              border: "thin",
              size: _ctx.upToLargeBreakpoint ? '2xs' : 'xs'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BalIcon, {
                  name: "akar-icons:cross",
                  size: "2xs"
                })
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('partner')), 1),
            (!_ctx.upToLargeBreakpoint)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t('emission_start')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('emission_end')), 1),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('balance')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalPoolRewardsToShow, (additionalPoolReward, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "invest-detail-container onsen-detail-value"
            }, [
              _createElementVNode("div", _hoisted_37, _toDisplayString(additionalPoolReward.partner), 1),
              (!_ctx.upToLargeBreakpoint)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(additionalPoolReward.startEmission), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, _toDisplayString(additionalPoolReward.endEmission), 1),
              _createElementVNode("div", _hoisted_40, [
                _createTextVNode(_toDisplayString(additionalPoolReward.totalAmount) + " ", 1),
                _createElementVNode("span", _hoisted_41, _toDisplayString(additionalPoolReward.totalAmountUsd), 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}